import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RouterModule } from '@angular/router';
import { forkJoin } from 'rxjs';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { SnackBarErrorConfig } from 'src/app/_utils/_material-import/snackbar-config';
import { DecimalFormatPipe } from 'src/app/_utils/_pipes/decimal-format.pipe';
import { CuentaRemuneradaData } from 'src/app/funds/public/_models/cuenta-remunerada-data';
import { Deposito } from 'src/app/funds/public/_models/deposito';
import { CuentaRemuneradaService } from 'src/app/funds/public/_services/cuenta-remunerada.service';
import { DepositosService } from 'src/app/funds/public/_services/depositos.service';
import { FichaProductosFunds } from 'src/app/home/_models/ficha-productos-funds';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

@Component({
  selector: 'app-ficha-productos-funds',
  standalone: true,
  imports: [SharedModule, RouterModule],
  templateUrl: './ficha-productos-funds.component.html',
  styleUrls: ['./ficha-productos-funds.component.scss'],
  providers: [DecimalFormatPipe]
})
export class FichaProductosFundsComponent implements OnInit
{

  fichaData: FichaProductosFunds[];
  isLoading: boolean = false;
  cuentaRemunerada: CuentaRemuneradaData;
  depositos: Deposito;

  constructor(
    private decimalPipe: DecimalFormatPipe,
    private _cuentaRemuneradaService: CuentaRemuneradaService,
    private _depositosService: DepositosService,
    private _matSnackBar: MatSnackBar
  ) { }

  ngOnInit(): void
  {
    this.getDatosRemuneradaDepositos();
  }

  ngAfterViewInit(): void {
    this.buildSwiper();
  }

  buildSwiper(): void
  {
    Swiper.use([Navigation, Pagination]);
    new Swiper('.swiperProductosFunds', {
      slidesPerView: 1.1,
      spaceBetween: 10,
      breakpoints: {
        320: {
          slidesPerView: 1.2,
          spaceBetween: 10
        },
        380: {
          slidesPerView: 1.5,
          spaceBetween: 10
        },
        500: {
          slidesPerView: 2,
          spaceBetween: 10
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 10
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 10
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 10
        }
      },
      pagination: {
        el: '.swiper-pagination-productos-funds',
        clickable: true
      },
    });
  }

  getDatosRemuneradaDepositos(): void
  {
    forkJoin([
      this._cuentaRemuneradaService.getCuentaRemuneradaData(),
      this._depositosService.getDatosDeposito()
    ]).subscribe({
      next: ([remunerada, deposito]) =>
      {
        this.isLoading = false;
        this.cuentaRemunerada = remunerada; 
        this.depositos = deposito;
      },
      complete: () =>
      {
        this.getFichaData();
      },
      error: e =>
      {
        this.getFichaData();
        this.isLoading = false;
        this._matSnackBar.open(this._depositosService.getServerErrors(e), 'x', new SnackBarErrorConfig());
      }
    })
  }

  private getFichaData(): void
  {
    this.fichaData = [
      {
        id: 1,
        title: `Cuenta <span class="secondary-funds-700">remunerada</span>`,
        imgSrc: './assets/images/funds/panel-inversor/ficha-producto/cuenta.png',
        subtitle: `
        <p class="p-display-bold text-center secondary-funds-700 my-3">
           ${this.decimalPipe.transform(this.cuentaRemunerada.tae, 'two-decimals')}% <span class="primary-900 p3-semibold">TAE</span>
        </p>`,
        btnLink: '/cuentas-remuneradas'
      },
      {
        id: 2,
        title: `<span class="secondary-funds-700">Depósitos</span>`,
        imgSrc: '/assets/images/funds/panel-inversor/ficha-producto/depositos.png',
        subtitle: `
         <p class="p-display-bold text-center secondary-funds-700 my-3">
          ${this.decimalPipe.transform(this.depositos.tae3MesesAutomatizada)}%<span class="primary-900 p1-semibold"> y </span>${this.decimalPipe.transform(this.depositos.tae3MesesNoAutomatizada)}%
          <span class="primary-900 p3-semibold"> TAE </span>
        </p>`,
        btnLink: '/depositos'
      },
      {
        id: 3,
        title: `Carteras <span class="secondary-funds-700">indexadas</span>`,
        imgSrc: './assets/images/funds/panel-inversor/ficha-producto/indexadas.png',
        subtitle: `
        <p class="p-display-bold text-center secondary-funds-700 my-3">
          0,13% <span class="primary-900 p3-semibold">COMISIÓN</span>
        </p>`,
        btnLink: '/indexadas'
      },
      {
        id: 4,
        title: `Carteras <span class="secondary-funds-700">temáticas</span>`,
        imgSrc: './assets/images/funds/panel-inversor/ficha-producto/tematicas.png',
        subtitle: `
         <p class="p-display-bold text-center secondary-funds-700 my-3">
          0,34%<span class="primary-900 p1-semibold"> a </span>0,98%
          <span class="primary-900 p3-semibold"> COMISIÓN </span>
        </p>`,
        btnLink: '/tematicas'
      }
    ]
  }
}
